import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { PostService } from '~/service/service.post';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';
import { Text } from '../view.box';

export const PostsScoreDialog = observer(() => {
	const [posts, ui] = useService(PostService, UIService);

	const handleConfirm = useCallback(async () => {
		ui.hideDialog();
		posts.recalculateScore();
	}, [posts, ui]);

	return (
		<Dialog open={ui.dialog === PostsScoreDialog} onClose={ui.hideDialog} maxWidth="md">
			<DialogTitle>Recalculate Post Scores</DialogTitle>
			<DialogContent>
				<Text>
					This action will recalculate the feed score of all posts based on their likes and comments. This is
					necessary after changing the FEED_SCORE_* settings or deleting many users.
				</Text>
				<br />
				<Text color="error.main" fontWeight="bold">
					Are you sure you want to proceed?
				</Text>
			</DialogContent>
			<DialogActions>
				<Button onClick={ui.hideDialog}>Cancel</Button>
				<Button color="primary" variant="contained" onClick={handleConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
});
